import {
    addSearchIndex,
    removeSearchIndex,
} from '../../common-client2/src/services/searchIndexer';

/**
 * @template T
 * @param {T[]} obj Collection of objects.
 * @param {string} search The string that will query the entire collection.
 * @returns {(T[]|[])} The filtered collection
 */
export const getFilteredObject = (obj, search) => {
    let data = obj || [];

    // Ensures it is an Array
    if (!Array.isArray(data)) {
        data = [data];
    }

    if (!search || !data.length) {
        return data;
    }

    const indexedData = data.map(addSearchIndex);
    const filteredData = indexedData.filter((dataItem) => dataItem.searchIndex?.includes(search.toLocaleLowerCase()));
    const cleanedUpFilteredData = filteredData.map(removeSearchIndex);

    return cleanedUpFilteredData;
};
